var Base = require('_js/base'),
  $ = require('jquery'),
  cart = require('_components/organisms/shopping-cart/shopping-cart-storage'),
  ko = require('knockout');

function Model(courseList) {
  var self = this;

  self.courses = ko.observableArray(courseList);
  self.courseListArray = ko.utils.arrayMap(courseList, function() {
    return {
      courseIsPurchased: ko.observable(false)
    };
  });

  self.addToCart = function(index, course, ev) {
    ev.preventDefault();
    self.courseListArray[index].courseIsPurchased(true);
    self.courseId = course.Id;
    cart.addCourseToCart(course);
  };
}

function TinyCourseList() {
  this.init();
}

TinyCourseList.prototype = new Base();

TinyCourseList.prototype.init = function() {
  $('[data-tiny-course-list]').each(function() {
    ko.applyBindings(new Model($(this).data('tiny-course-list')), this);
  });
};

module.exports = TinyCourseList;
